/**
 * The FAQ, grouped. Text lives in the i18n tables as `faq.<id>.q` / `faq.<id>.a` (answers may use
 * `[label](href)` and `**bold**`). The landing page shows `LANDING_FAQ`; /faq shows every group.
 */
export const FAQ_GROUPS = [
  { id: 'about', items: ['notDiagnosis', 'hasDiagnosis', 'worried', 'different', 'whoMade'] },
  { id: 'child', items: ['ages', 'areas', 'howLong', 'bands', 'howOften', 'moreChildren'] },
  { id: 'reports', items: ['whatFree', 'fullReport', 'share', 'notHappy'] },
  { id: 'privacy', items: ['safe', 'delete', 'urgent'] },
] as const;

export type FaqId = (typeof FAQ_GROUPS)[number]['items'][number];

export const LANDING_FAQ: FaqId[] = ['notDiagnosis', 'hasDiagnosis', 'worried', 'whatFree', 'share', 'safe'];

export const ALL_FAQ: FaqId[] = FAQ_GROUPS.flatMap((g) => [...g.items]);
